import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-bnpl',
  templateUrl: './loader-bnpl.component.html',
  styleUrls: ['./loader-bnpl.component.scss']
})
export class LoaderBnplComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {}

}
